class SizePage extends HTMLElement {
  toggleSwitch?: HTMLElement | null
  activeMeasurement: "cm" | "inches" = "cm"
  isUS: boolean = false
  isKids: boolean = false

  connectedCallback() {
    this.toggleSwitch = this.querySelector(".toggle-switch")
    this.toggleSwitch?.addEventListener("click", this.toggleCmInch.bind(this))
    this.toggleRows = this.toggleRows.bind(this)

    this.toggleRows(false)
    
    const bodyElement = document.querySelector("body")
    if (bodyElement) {
      // check Kids site
      this.isKids = bodyElement.classList.contains("is-industrie-kids")
      // check US site
      this.isUS = bodyElement.classList.contains("is-industrie-us")
      if ( this.isUS ) {
        this.toggleRows(true)
        this.switchCmIn()
      }
    }
  }

  toggleRows(isUS:boolean) {
    const allRows = Array.from(this.querySelectorAll("tr"))
    const mode = isUS ? ["none", "table-row"] : ["table-row", "none"]
    allRows.forEach((row) => {
      const isCm = row.classList.contains("cm")
      const isInches = row.classList.contains("inches")

      if (this.activeMeasurement === "cm") {
        if (isCm) row.style.display = mode[0]
        if (isInches) row.style.display = mode[1]
      }

      if (this.activeMeasurement === "inches") {
        if (isCm) row.style.display = mode[1]
        if (isInches) row.style.display = mode[0]
      }
    })
  }

  setDefault() {
    const cells = this.querySelectorAll("td")
    cells.forEach((cell: HTMLElement) => {
      if (cell.dataset.originalValue) {
        if (this.toggleSwitch?.classList.contains("active")) {
          cell.innerText = (parseFloat(cell.dataset.originalValue) / 2.54).toFixed(1)
        } else {
          cell.innerText = cell.dataset.originalValue
        }
      } else if (!isNaN(parseFloat(cell.innerText))) {
        cell.dataset.originalValue = cell.innerText
        if (this.toggleSwitch?.classList.contains("active")) {
          cell.innerText = (parseFloat(cell.dataset.originalValue) / 2.54).toFixed(1)
        }
      }
    })
  }

  toggleCmInch() {
    this.toggleSwitch?.classList.toggle("active")
    if (this.isKids) {
      this.setDefault()
    } else {
      this.activeMeasurement = this.activeMeasurement === "cm" ? "inches" : "cm"
      this.toggleRows(this.isUS)
    }
  }

  switchCmIn() {
    var spanElements = this.toggleSwitch?.querySelectorAll('span')
    if(spanElements) {
        var temp = spanElements[0].innerText
        spanElements[0].innerText = spanElements[2].innerText
        spanElements[2].innerText = temp
    }
  }
}

customElements.define("size-page", SizePage)
